import { useState, useRef, useId } from "react";
import { getCurrentProject } from "../sessionManager";
import { Slider as PrimeSlider } from "primereact/slider";
import throttle from 'lodash.throttle'
import { getWidgetData } from "../utils/parameters";

export const Slider = ({ className="", value, step, min, max, onNewValue, orientation='horizontal', style, label, labelSize="12px", output, noLabel=false, noOutput=false, isRange=false, colorRange=false, throttleDeps=[], ...props }) => {
    const widgetData = getWidgetData(props['data-widget-id']);
    if (widgetData) label ??= widgetData.label?.ca;

    const [isDragging, setIsDragging] = useState(false);
    const handleChange = useRef(throttle((value, ...throttleDeps) => onNewValue(value, ...throttleDeps), getCurrentProject().continuousControlThrottleTime));
    const sliderId = useId();
    // can't use useFocus and FloatingValue because PrimeSlider doesn't give us a ref to attach to
    // TODO: substitute PrimeSlider for another widget
    return (
        <div className={`slider ${orientation} ${className}`} style={style}>
            <PrimeSlider {...props} className={`${colorRange ? "color-range" : ""}`} id={sliderId} orientation={orientation} value={value} step={step} min={min} max={max} onChange={e => {
                const newValue = e.value;
                const oldValue = value;
                handleChange.current(newValue, ...throttleDeps, oldValue);
            }} range={isRange} onPointerDown={e => {if (e.target.className.includes("p-slider-handle")) setIsDragging(true)}} onSlideEnd={() => setIsDragging(false)}/>
            {!noLabel && <label style={{fontSize: labelSize}} htmlFor={sliderId}>{label}</label>}
            {!noOutput && <output className={`parameter-value-display compatibility ${isDragging ? "show" : ""}`} htmlFor={sliderId}>{output}</output>}
        </div>
    )
};